import { Notification } from "../domain/Notification";
import { NotificationRepository } from "../domain/NotificationRepository";
import { client } from "../../../api/client";

export class APINotificationRepository implements NotificationRepository {
  async get_data(): Promise<{[key: string]: string[] | Notification[]} > {
    return await client
      .post(`query/`,{query:'user.notifications',args:{unread_only:true,type:'app'}})
      .then((response) => response.data);
  }
  async mark_as_read(user_id,noti_id): Promise<{[key: string]: string} > {
    return await client
      .post(`sync_command_bus/`,{command:{cmd_name:'mark.noti.as.read',user_id:user_id,noti_id:noti_id}})
      .then((response) => response.data);
  }
}
